module.exports = __webpack_public_path__ + "static/media/CEPpernoite.32025bda.svg";